import { signIn, SignInInput } from "aws-amplify/auth"

export const SECURITY_SIGN_IN_ERROR_MESSAGE =
    "Unable to sign in due to security reasons. Please reset your password using the link below."
export const INCORRECT_SIGN_IN_ERROR_MESSAGE =
    "Incorrect email or password. Please try again or reset your password using the link below."

const throwError = (error: unknown): never => {
    const errorObject = typeof error === "object" && error !== null ? error : {}
    if ("name" in errorObject) {
        if (errorObject.name === "UserNotConfirmedException") {
            throw new Error(SECURITY_SIGN_IN_ERROR_MESSAGE)
        }
    }
    // NotAuthorizedException is the error type for both security issues and incorrect credentials
    if ("message" in errorObject) {
        switch (errorObject.message) {
            case "Unable to login because of security reasons.":
                throw new Error(SECURITY_SIGN_IN_ERROR_MESSAGE)
            case "Incorrect username or password.":
                throw new Error(INCORRECT_SIGN_IN_ERROR_MESSAGE)
            default:
                throw error
        }
    }
    throw error
}

export const authServices = {
    async handleSignIn(input: SignInInput) {
        try {
            return await signIn(input)
        } catch (error) {
            return throwError(error)
        }
    },
}
